module.exports = {
  schema: {
    name: '庫存',
    type: 'Object',
    contents: {
      name: {
        type: 'String',
        name: '庫別',
      },
      skuRef: {
        type: 'ObjectId',
        reference: 'skus',
        name: '存貨單元',
        refKeys: ['productRef'],
        input: 'select',
      },
      qty: {
        type: 'Number',
        name: '數量',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'name', width: 100 },
        { key: 'skuRef', width: 100 },
        { key: 'qty', width: 130 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '庫存',
          rows: [
            [{ key: 'name' }],
            [{ key: 'skuRef' }],
            [{ key: 'qty' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/stocks.js